module.exports = __webpack_public_path__ + "img/26.ad872e1f.jpg";